import { FC, useCallback, useEffect } from "react";
import { ClickAwayListener, Drawer, Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { budgetDetailsDrawerIdSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsDrawerIdSelector";
import { usePanelHorizontalResize } from "@/components/utils/hooks/usePanelHorizontalResize";
import { ResourceDetailsDragHandler } from "@/components/pages/common/resource-details/components/ResourceDetailsDragHandler";
import { BudgetDetailsHeader } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/header/BudgetDetailsHeader";
import { closeBudgetDetailsDrawerThunk } from "@/store/budgets/thunks/drawer/closeBudgetDetailsDrawerThunk";
import { initiateBudgetsDetailsDrawerThunk } from "@/store/budgets/thunks/drawer/initiateBudgetsDetailsDrawerThunk";
import { BudgetDetailsBody } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/BudgetDetailsBody";

export const BudgetDetailsDrawer: FC = () => {
  const dispatch = useAppDispatch();
  const { width, handleMouseDown } = usePanelHorizontalResize(
    resizingDefaultParams,
  );
  const budgetId = useAppSelector(budgetDetailsDrawerIdSelector);
  const open = !!budgetId;

  const closeHandler = useCallback(() => {
    dispatch(closeBudgetDetailsDrawerThunk());
  }, [dispatch]);

  useEffect(() => {
    if (!budgetId) {
      return;
    }

    dispatch(initiateBudgetsDetailsDrawerThunk());
  }, [budgetId, dispatch]);

  return (
    <ClickAwayListener onClickAway={closeHandler} mouseEvent="onMouseDown">
      <Drawer
        anchor="right"
        open={open}
        onClose={closeHandler}
        variant={open ? "permanent" : undefined}
        PaperProps={{ sx: { width, overflow: "hidden" } }}
      >
        <Stack height="100%" overflow="hidden" position="relative">
          <BudgetDetailsHeader />

          <BudgetDetailsBody />

          <ResourceDetailsDragHandler onMouseDown={handleMouseDown} />
        </Stack>
      </Drawer>
    </ClickAwayListener>
  );
};

const resizingDefaultParams = {
  defaultWidthPercent: 55,
  minWidthPercent: 45,
  key: "budgetsDetailsDrawer",
};
